


<div mat-dialog-title class="d-flex justify-content-between align-items-center" style="margin-bottom:14px">
  <div class="h4 no-margins">
    {{data.title | translate}}
  </div>
  <button mat-icon-button mat-dialog-close cdkFocusInitial>
    <mat-icon aria-label="Close Dialog">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="key-pad">
  <div class="_value" [ngClass]="{'text-danger': response.invalid, _revo: appService.regionArgs.currencySignAtStart }">
    <div>&nbsp;{{response.amountText}}&nbsp;</div>
    <div class="_currency">{{data.currency}}</div>
  </div>
  <div class="row keys">
    @for (key of keys; track key) {
      <div class="col-4 btn-keypad">
        <button mat-fab (click)="setAmaountKey(key)" [disabled]="key == null">
          @if (key === null) {
            {{key}}
          }
          @if (key != 'back') {
            {{key}}
          }
          @if (key == 'back') {
            <mat-icon>backspace</mat-icon>
          }
        </button>
      </div>
    }
  </div>
</div>

<div mat-dialog-actions>
  <div class="text-center flex-grow-1 mb-3 mt-2">
    <button type="button" mat-stroked-button color="accent" [mat-dialog-close]="response.wasChanged ? response : null" class="lg rounded btn-block b-drak" [disabled]="response.invalid">
      {{(data.confirmText || 'OK') | translate}}
    </button>
  </div>
</div>


